import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environment/environment';
import { normalizeMaterialPlannerValue } from '../../../../surveyJS-custom-questions/event-material-planner.util';

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function extractMaterialLinesFromFormData(
  data: Record<string, unknown>
): ReturnType<typeof normalizeMaterialPlannerValue>['items'] {
  const raw =
    data['event_material_planner'] ??
    data['event_material_requests'] ??
    null;
  return normalizeMaterialPlannerValue(raw).items;
}

/**
 * POST material requests for each created event guid.
 */
export function postEventMaterialRequestsForGuids(
  http: HttpClient,
  eventGuids: string[],
  data: Record<string, unknown>
): Observable<{ failed: string | null }> {
  const lines = extractMaterialLinesFromFormData(data);
  if (lines.length === 0 || eventGuids.length === 0) {
    return of({ failed: null });
  }
  const validGuids = eventGuids.filter((g) => UUID_REGEX.test(g));
  if (validGuids.length === 0) {
    return of({ failed: null });
  }

  const calls: Observable<unknown>[] = [];
  for (const guid of validGuids) {
    for (const line of lines) {
      calls.push(
        http
          .post(`${environment.apiUrl}/events/${guid}/materials`, {
            material_id: line.material_id,
            quantity: line.quantity,
            instructor_notes: line.instructor_notes || undefined,
            location_id: line.location_id ?? undefined,
          })
          .pipe(
            catchError((err) => {
              const msg =
                err?.error?.message ||
                `Materiel "${line.name}" kunne ikke bookes.`;
              return throwError(() => new Error(msg));
            })
          )
      );
    }
  }

  return forkJoin(calls).pipe(
    map(() => ({ failed: null })),
    catchError((err: unknown) =>
      of({
        failed:
          (err instanceof Error ? err.message : null) ||
          'Eventet blev oprettet, men materiel-booking fejlede. Ret materiel på eventsiden.',
      })
    )
  );
}
